// extracted by mini-css-extract-plugin
export default {"currencyForm":"ChangeCurrencyButton_currencyForm__5vsQL"};